interface LoadingSpinnerProps {
  text?: string;
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
}

export default function LoadingSpinner({ text, size = 'md', fullScreen }: LoadingSpinnerProps) {
  const sizeClasses = { sm: 'h-5 w-5', md: 'h-8 w-8', lg: 'h-12 w-12' };

  return (
    <div
      className={`flex flex-col items-center justify-center ${fullScreen ? 'min-h-screen' : 'py-12'}`}
      role="status"
      aria-label="Loading"
    >
      <svg className={`${sizeClasses[size]} animate-spin text-primary-500`} fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
      </svg>
      {text && <p className="mt-3 text-sm text-gray-500">{text}</p>}
    </div>
  );
}
